import '/components/info-blocks/info-blocks.scss';
